'use strict';

exports.__esModule = true;
var FILTER_NAMES = exports.FILTER_NAMES = {
  BRANCHES: 'BRANCHES',
  ROOMS: 'ROOMS',
  DOCTORS: 'DOCTORS'
};

var ALL_BRANCHES_VALUE = exports.ALL_BRANCHES_VALUE = 'ALL_BRANCHES';

var CONFIRMATION_SELECT_TYPES = exports.CONFIRMATION_SELECT_TYPES = {
  THIS_WEEK: 'THIS_WEEK',
  NEXT_WEEK: 'NEXT_WEEK',
  THIRD_WEEK: 'THIRD_WEEK',
  FOURTH_WEEK: 'FOURTH_WEEK'
};

var PAGE_SIZE = exports.PAGE_SIZE = 10;

var CALENDAR_EMPTY_ERROR = exports.CALENDAR_EMPTY_ERROR = 'Select start/end dates from the Calendar';

var FILTER_EMPTY_ERROR = exports.FILTER_EMPTY_ERROR = 'Select a doctor from the filter';

var DEFAULT_ERROR_MESSAGE = exports.DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later';